module.exports = __webpack_public_path__ + "img/2003488.c6622131.jpg";